export default class APLinesRowData {
    constructor(value) {
        this.chargeType = value.chargeType[0] || "";
        this.brand = value.brand[0] || "";
        this.chargePeriod = value.chargePeriod[0] || "";
        this.chargeCode = value.chargeCode[0] || "";
        this.raNumber = value.raNumber[0] || "";
        this.rentingCountry = value.rentingCountry[0] || "";
        this.cOutLoc = value.cOutLoc[0] || "";
        this.cOutDate = value.cOutDate[0] || "";
        this.costCentre = value.costCentre[0] || "";
        this.rentTM = value.rentTM[0] || "";
        this.bonusRate = value.bonusRate[0] || "";
        this.foreignComm = value.foreignComm[0] || "";
        this.domesticComm = value.domesticComm[0] || "";
        this.rentingCurrency = value.rentingCurrency[0] || "";
        this.accountNo = value.accountNo[0] || "";
        this.billingCountry = value.billingCountry[0] || "";
        this.commissionBillValue = value.commissionBillValue[0] || "";
        this.billingCurrency = value.billingCurrency[0] || "";
        this.bonusAmount = value.bonusAmount[0] || "";
        this.exchRate = value.exchRate[0] || "";
        this.currencyCode = value.currencyCode[0] || "";
    }
}